module.exports = __webpack_public_path__ + "static/media/arrow.cda5a850.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/arrow.svg
// module id = 232
// module chunks = 0